(function () {
  var drawer = document.getElementById('cart-drawer');
  if (!drawer) return;

  var backdrop = document.createElement('div');
  backdrop.className = 'dp-cart-backdrop';
  document.body.appendChild(backdrop);

  function isOpen() {
    var dialog = drawer.querySelector('dialog');
    return dialog ? dialog.hasAttribute('open') : false;
  }

  function sync() {
    backdrop.classList.toggle('is-open', isOpen());
  }

  var observer = new MutationObserver(sync);
  var dialog = drawer.querySelector('dialog');
  if (dialog) {
    observer.observe(dialog, { attributes: true, attributeFilter: ['open'] });
  }

  backdrop.addEventListener('click', function () {
    var closeBtn = drawer.querySelector('[on\\:click*="close"]');
    if (closeBtn) closeBtn.click();
  });

  sync();
})();